var map = {
	"./block-btn.svg": "cd07",
	"./eraser-btn.svg": "0edc",
	"./fav-btn.svg": "fa5f",
	"./fav-non-btn.svg": "7635",
	"./international.svg": "17df",
	"./ko.svg": "f0a1",
	"./next-btn.svg": "c003",
	"./pre-btn.svg": "699d",
	"./zh.svg": "d0aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";